import React from 'react';
import { DateTime, Duration } from 'luxon';
import { useInterval } from 'usehooks-ts';

import Intro from './Intro';
import CurrentTime from './CurrentTime';
import CurrentStatus from './CurrentStatus';
import Location from './Location';

interface Period {
  start: DateTime;
  end: DateTime;
  type: string;
}

type Timeline = Array<Period>;

export default function TimeAttendance() {
  const [start, setStart] = React.useState<DateTime | undefined>(undefined);
  const [onBreak, setOnBreak] = React.useState<DateTime | undefined>(undefined);
  const [, setTimeline] = React.useState<Timeline>([]);
  const [duration, setDuration] = React.useState<Duration | undefined>(undefined);

  const handleClockInOutClick = () => {
    if (!start) {
      setStart(DateTime.now());
    } else {
      setTimeline((t) => ([...t, { start, end: DateTime.now(), type: 'work' }]));
      setStart(undefined);
      setDuration(undefined);
    }
  };

  const handleBreakClick = () => {
    if (!onBreak) {
      setOnBreak(DateTime.now());
      setTimeline((t) => ([...t, { start, end: DateTime.now(), type: 'work' }]));
      setStart(undefined);
    } else {
      setTimeline((t) => ([...t, { start: onBreak, end: DateTime.now(), type: 'break' }]));
      setOnBreak(undefined);
      setStart(DateTime.now());
    }
  };

  useInterval(() => {
    if (onBreak || start) {
      const d = DateTime.now().diff(onBreak || start);
      setDuration(d);
    }
  }, 500);

  return (
    <div className="p-16 w-100 h-100">
      <div className="time-attendance">
        <div className="time-attendance-content">
          <CurrentTime />
          <Intro />
          <CurrentStatus
            running={start !== undefined}
            onBreak={onBreak !== undefined}
            value={duration}
          />
          <Location />
        </div>
        <div className="time-attendance-footer">
          <button type="button" className="btn" onClick={handleClockInOutClick} disabled={onBreak !== undefined}>
            {(start !== undefined || onBreak !== undefined) ? 'Clock Out' : 'Clock In'}
          </button>
          <button type="button" className="btn btn-outline" onClick={handleBreakClick} disabled={start === undefined && onBreak === undefined}>
            {onBreak !== undefined ? 'End Break' : 'Break'}
          </button>
        </div>
      </div>
    </div>
  );
}
